var map = {
	"./Muradyan-circle.jpg": 38539,
	"./Muradyan-circle.webp": 23745,
	"./Muradyan.jpg": 7450,
	"./Muradyan.webp": 74322,
	"./davidkina-circle.jpg": 67034,
	"./davidkina-circle.webp": 79184,
	"./davidkina.png": 53747,
	"./davidkina.webp": 35419,
	"./ferdman-circle.png": 73797,
	"./ferdman-circle.webp": 17570,
	"./ferdman.png": 78507,
	"./ferdman.webp": 69860,
	"./filimonova-circle.png": 49366,
	"./filimonova-circle.webp": 23704,
	"./filimonova.png": 13247,
	"./filimonova.webp": 59899,
	"./loseva-circle.png": 99361,
	"./loseva-circle.webp": 28200,
	"./loseva.png": 80722,
	"./loseva.webp": 4961,
	"./malafeeva-circle.png": 1669,
	"./malafeeva-circle.webp": 35186,
	"./malafeeva.png": 10483,
	"./malafeeva.webp": 27671,
	"./nedbay-circle.png": 54389,
	"./nedbay-circle.webp": 31848,
	"./nedbay.png": 13254,
	"./nedbay.webp": 80875,
	"./oleynikova-circle.png": 94077,
	"./oleynikova-circle.webp": 77059,
	"./oleynikova.jpg": 82798,
	"./oleynikova.webp": 85104,
	"./peremutov-circle.png": 18873,
	"./peremutov-circle.webp": 9546,
	"./peremutov.png": 41392,
	"./peremutov.webp": 59575,
	"./potapov-circle.png": 99778,
	"./potapov-circle.webp": 76149,
	"./potapov.png": 21651,
	"./potapov.webp": 59171,
	"./slide-1.jpg": 83317,
	"./slide-2.jpg": 58407,
	"./slide-3.jpg": 6639,
	"./slide-4.jpg": 76243,
	"./speaker-1-circle.png": 36425,
	"./speaker-1-circle.webp": 41187,
	"./speaker-1.png": 75130,
	"./speaker-1.webp": 83730,
	"./vebber-circle.png": 90336,
	"./vebber-circle.webp": 90386,
	"./vebber.png": 27969,
	"./vebber.webp": 48010
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55172;